let EmailBtn = xClass("EmailBtn", function () {
    return cc.Node.create();
})

EmailBtn.prototype.ctor = function () {
    let self = this;
    let icon = cc.Sprite.createWithSpriteFrameName("homeScene/message.png");
    self.addChild(icon);
    icon.y = -3;
    self.posIndex = 5;
    self.EmailMgr = EmailManager.getInstance();
    //
    let newText = cc.LabelTTF.create("信箱", FONT_DEF.sidebox)
    newText.setPosition(0, -47);
    self.addChild(newText, 2, "txt");
    //
    let prompt = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt.png");
    prompt.setAnchorPoint(0.5, 0.5);
    prompt.setPosition(icon.width / 2 + 30, icon.height / 2 + 30);
    prompt.setScale(0.8);
    icon.addChild(prompt);
    self.prompt = prompt;
    self.updatePrompt();

    quickBuildUIButton(icon, () => {
        self.onCick();
    });
}

EmailBtn.prototype.onCick = function () {
    let self = this;
    if (self.isBusy) return;
    self.isBusy = true;

    if (!self.EmailMgr.lastGetInfoTime) {
        self.EmailMgr.getInfo().then(function (evt) {
            EmailManager.getInstance().openPanel(() => {
                self.isBusy = false;
            }, () => {
                self.updatePrompt();
            });
        }).catch(() => {
            self.isBusy = false;
            self.updatePrompt();
        });
    } else {
        EmailManager.getInstance().openPanel(() => {
            self.isBusy = false;
        }, () => {
            self.updatePrompt();
        });
    }

    DCAssist.dc4NewIconPanel("mail");
}

EmailBtn.prototype.updatePrompt = function () {
    let self = this;
    const isPrompt = self.EmailMgr.hasRedDot();
    self.prompt.setVisible(isPrompt);
}
module.exports = EmailBtn;
